import { isMobile, isTablet } from '../base.js'

function filterBtnText() {
    const filtersBtn = $('.filters-unveil-button-wrapper .unveil-button')
    const isVisible = $('.filters.visible').length > 0

    filtersBtn
        .text(isVisible ? 'Skrýt filtr' : 'Filtrovat')
        .attr('data-text', isVisible ? 'Filtrovat' : 'Skrýt filtr')
}
function filtersBtn(num) {
    return /* HTML */ `
        <div class="btn-wrapper">
            <a href="#products" class="btn btn-default filtered-products-btn">
                Zobrazit produkty <span class="filtered-products-count">(${num})</span>
            </a>
        </div>
    `
}

function restructureFilters() {
    // Restructure HTML
    $('#price-filter-form').insertBefore('.filter-section-boolean .param-filter-top')
    $('#filters .slider-wrapper').insertBefore('.filter-section-boolean .param-filter-top')
    $('.filter-section-boolean').prependTo('#category-filter-hover')

    // Přidaní tlačítka "zobrazit produkty"
    if (!isTablet()) {
        const filterWrapper = document.querySelector('#category-filter-hover')
        const filteredProductsCount = $('.filter-total-count strong').text()
        const btn = filtersBtn(filteredProductsCount)

        if (filterWrapper) {
            filterWrapper.insertAdjacentHTML('beforeend', btn)
        }
        $('#clear-filters').insertAfter('.filtered-products-btn')
    } else {
        $('#category-filter-hover').append($('#clear-filters'))
    }

    // $('#clear-filters a').text(_t('category.clearFilters'))
    $('#clear-filters').addClass('btn btn-primary clear-filters-btn')

    if ($('.type-manufacturer-detail').length) {
        $('#filters-wrapper').insertAfter('#category-header')
    }

    // Změna fieldset elementů na DIV pro účel vytvoření flex kontejneru
    $('.filter-section form:not(#price-filter-form) fieldset').each(function () {
        const div = $('<div>').addClass('fieldset').html($(this).html())
        $(this).replaceWith(div)
    })

    // filtr tlačítko
    filterBtnText()
}
function adjustFilterSectionSize() {
    $('.filter-section .fieldset').each(function () {
        const filterCount = $(this).children('div').length
        const filterSection = $(this).closest('.filter-section')

        const addClasses = (section) => {
            section.addClass('wide-section')
            section.addClass('section-size-adjusted')
        }

        if (
            filterSection.hasClass('filter-section-collection') ||
            filterSection.hasClass('filter-section-manufacturer')
        ) {
            addClasses(filterSection)
        }

        if (isMobile() && !filterSection.hasClass('filter-section-boolean')) {
            filterSection.addClass('openable-section')
        } else if (
            !filterSection.hasClass('filter-section-boolean') &&
            !filterSection.hasClass('filter-section-manufacturer')
        ) {
            filterSection.addClass('openable-section')
        }

        if (filterCount > 12) {
            filterSection.addClass('columns-scroll')
        }

        $('.columns-scroll').each(function () {
            handleColumnsScroll()
        })
    })
}

function handleColumnsScroll() {
    $('.columns-scroll').each(function () {
        const currentSection = $(this)
        const fieldset = currentSection.find('.fieldset')

        handleScrollOverlayClick(currentSection, fieldset)
        scrollOverlayEvent(fieldset)
    })
}

function scrollOverlayEvent(element) {
    element.addClass('scroll-overlay')

    const post = element.closest('form')

    post.on('scroll', function () {
        if (post.scrollTop() === 0) {
            element.addClass('scroll-overlay')
        } else {
            element.removeClass('scroll-overlay')
        }
    })
}
function handleScrollOverlayClick(currentSection, element) {
    const post = element.closest('form')
    if (!currentSection.find(`.scroll-overlay-element`).length) {
        element.prepend(`<div class="scroll-overlay-element"></div>`)

        $(currentSection.find('.scroll-overlay-element')).on('click', () => {
            post.animate(
                {
                    scrollTop: 25,
                },
                {
                    duration: 300,
                    easing: 'swing',
                }
            )
        })
    }
}
function closableFilterSections() {
    $('.filter-section h4:not(.event-added)').click(function () {
        $('.slider-wrapper').removeClass('open')
        $(this).closest('.filter-section').toggleClass('open')
    })
    $('.filter-section h4').each(function () {
        $(this).addClass('event-added')
    })

    $('.filter-label.active').each(function () {
        $(this).closest('.filter-section').addClass('open')
    })
}

function handleContentLoadedFilters() {
    restructureFilters()
    adjustFilterSectionSize()
    closableFilterSections()
    $('.filter-section-count').remove()
}

export function initFilters() {
    handleContentLoadedFilters()

    document.addEventListener('ShoptetDOMPageContentLoaded', async function () {
        handleContentLoadedFilters()
    })
}
